'use client';

import { FC } from 'react';

import { IconShare } from 'src/general/Icons/IconShare';
import { Breadcrumbs } from 'src/general/components/Breadcrumbs/Breadcrumbs';
import { BreadcrumbsJsonLD } from 'src/general/components/Breadcrumbs/BreadcrumbsJsonLD';
import { Button } from 'src/general/components/Button/Button';
import { useSharePage } from 'src/general/helpers/useSharePage';
import { generatePdpBreadcrumbs } from 'src/pdp/helpers/pdpContentHelpers';
import { ProductDetailsPayload } from 'src/types/ProductDetail.type';

import styles from './PdpHeader.module.scss';

interface Props {
  productDetails: ProductDetailsPayload;
}

export const PdpHeader: FC<Props> = ({ productDetails }) => {
  const { sharePage } = useSharePage();
  const breadcrumbsItems = generatePdpBreadcrumbs(new Map([]), productDetails);

  return (
    <section className={styles.root}>
      <Breadcrumbs items={breadcrumbsItems} className={styles.breadcrumbs} enableLastLink />
      <BreadcrumbsJsonLD items={breadcrumbsItems} />
      <Button
        variant="tertiary"
        size="small"
        startIcon={<IconShare />}
        onClick={sharePage}
        data-testid="PDP_HEADER_SHARE_BUTTON"
      >
        Share
      </Button>
    </section>
  );
};
